/**
 * A screen shown as one tab of a room.
 *
 * Deep thinking keeps its nine engines but shows them as three rooms of three
 * tabs. Each tab is the screen it always was; inside a room it does not draw
 * its own page heading — the room's heading and tabs stand above it, and the
 * screen's own title becomes the tab's sub-heading.
 */
import { createContext, useContext, type ReactNode } from "react";

export const RoomContext = createContext<ReactNode | null>(null);

/** The room's heading and tabs, when the screen is shown inside a room. */
export const useRoomBar = () => useContext(RoomContext);
